import agendaVideo from '../../assets/agenda_web_video.mp4';
import icone from '../../assets/wpp-icon-gg.svg';
import phone from '../../assets/phone.svg';
import calendar from '../../assets/calendar.svg';
import evolucao from '../../assets/evolucao.svg';
import confirma from '../../assets/wpp-confirma.svg';
import receita from '../../assets/receita-verde.svg';
import atestado from '../../assets/atestado-verde.svg';
import exame from '../../assets/exame-verde.svg';

const agendaWeb = {
  nome: 'agenda web',
  span: 'Agenda Web',
  titulo: 'Transforme a praticidade em sua rotina médica com nossa ',
  desc: 'Acesse e atualize sua agenda em qualquer lugar, a qualquer hora, com nossa Agenda Web, levando o cuidado com seus pacientes para além do desktop.',
  media: agendaVideo,
  icone: icone,
  pontos: [
    {
      titulo: 'Visualizar Agenda',
      desc: 'Verifique seus pacientes agendados de onde estiver com agilidade',
      svg: calendar,
    },
    {
      titulo: 'Marcar Atendido',
      desc: 'Após o tele-atendimento do paciente, marque-o como atendido pela Agenda Web',
      svg: confirma,
    },
    {
      titulo: 'Evolua o Prontuário',
      desc: 'Preencha uma nova evolução do atendimento paciente de onde estiver',
      svg: evolucao,
    },
    {
      titulo: 'Receituário Digital',
      desc: 'Permite emitir receitas de forma prática, segura e totalmente integrada ao fluxo de atendimento.',
      svg: receita,
    },
    {
      titulo: 'Atestados Médicos',
      desc: 'Emissão facilitada de documentos oficiais, garantindo rapidez e precisão nas informações fornecidas',
      svg: atestado,
    },
    {
      titulo: 'Pedido de Exames',
      desc: 'Podem ser gerados de maneira simples e organizada, assegurando agilidade no encaminhamento dos pacientes',
      svg: exame,
    },
    {
      titulo: 'Acesso pelo celular',
      desc: 'A Agenda Web é totalmente responsiva, acessada pelo celular, tablet ou computador',
      svg: phone,
    },
  ],
};
export default agendaWeb;
